import { Select } from 'antd';
import * as React from 'react';
import { defaultSelectFormatter } from '../../../utils/helpers/select_helpers';

const { Option } = Select;

interface SelectFieldProps {
  placeholder: string;
  label: string;
  defaultValue?: any;
  options?: any[];
  allowClear: boolean;
  onChanged?: (any) => any;
  debug?: boolean;
  service?: () => any;
  [prop: string]: any;
}

const SelectField: React.FC<SelectFieldProps> = React.forwardRef(
  (
    {
      label,
      defaultValue,
      options,
      allowClear = true,
      hasFeedback = false,
      showAll = false,
      debug = false,
      service,
      loadOnFirstClick = false,
      ...props
    },
    ref
  ) => {
    const SelectOptions = React.useMemo(() => {
      let opts: any = [];

      if (options) opts = options;
      else if (service) {
        opts = service();
      }
      return defaultSelectFormatter(opts) || [];
    }, [options, service]);

    return (
      <Select
        labelInValue={false}
        allowClear={allowClear}
        optionLabelProp="label"
        filterOption={(input, option: any) => {
          let filtered = true;
          try {
            filtered =
              option?.children?.join(' ')?.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              //@ts-ignore
              option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          } catch (e) { }

          return filtered;
        }}
        showSearch
        {...props}
        onClear={() => {
          props.onChange && props.onChange(null);
        }}
        onChange={(value = null, option) => {
          if (props.onChange) {
            props.onChange(value ?? null, option, null);
          }
        }}
        options={SelectOptions}
      ></Select>
    );
  }
);

export default SelectField;
